/* PureState PDP image slider.
   - Delegated clicks (arrows/dots) survive section re-renders.
   - Dot sync binds directly to each track; rebinds on shopify:section:load
     (theme editor re-render) because element scroll events are not reliably
     observable from a document-level capture listener.
   - goTo sets the active dot explicitly and uses CSS scroll-behavior for
     animation, with an instant-jump fallback when the scroll-snap engine
     cancels the smooth scroll (Chromium quirk). */
(function () {
  'use strict';

  function sliderOf(el) {
    return el && el.closest('[data-pdp-slider]');
  }

  function trackOf(slider) {
    return slider.querySelector('[data-pdp-track]');
  }

  function dotsOf(slider) {
    return Array.prototype.slice.call(slider.querySelectorAll('[data-pdp-dot]'));
  }

  function currentIndex(track) {
    if (!track || !track.clientWidth) return 0;
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function setActiveDot(slider, i) {
    dotsOf(slider).forEach(function (d, j) {
      d.classList.toggle('is-active', j === i);
    });
  }

  function goTo(slider, i) {
    var track = trackOf(slider);
    if (!track || !track.children.length) return;
    var count = track.children.length;
    if (i < 0) i = count - 1;
    if (i > count - 1) i = 0;
    var target = track.clientWidth * i;
    setActiveDot(slider, i);
    track.scrollTo({ left: target });
    setTimeout(function () {
      if (Math.abs(track.scrollLeft - target) > 2) {
        track.scrollTo({ left: target, behavior: 'instant' });
      }
    }, 450);
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var prev = e.target.closest('[data-pdp-prev]');
    var next = e.target.closest('[data-pdp-next]');
    var dot = e.target.closest('[data-pdp-dot]');
    var slider = sliderOf(prev || next || dot);
    if (!slider) return;
    var track = trackOf(slider);
    if (prev) goTo(slider, currentIndex(track) - 1);
    if (next) goTo(slider, currentIndex(track) + 1);
    if (dot) goTo(slider, dotsOf(slider).indexOf(dot));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (!(e.target instanceof Element)) return;
    var track = e.target.closest('[data-pdp-track]');
    if (!track) return;
    e.preventDefault();
    goTo(sliderOf(track), currentIndex(track) + (e.key === 'ArrowRight' ? 1 : -1));
  });

  function bindTrack(track) {
    if (track.__pdpBound) return;
    track.__pdpBound = true;
    var slider = sliderOf(track);
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        setActiveDot(slider, currentIndex(track));
      });
    }, { passive: true });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pdp-track]')).forEach(bindTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  window.__pdpSliderLoaded = true;
})();
